const extrctLinkData = require("./extractLinkData");

module.exports = function extractButtonData(entity, sitemap, singleRelationships) {
	const { field_color, field_button_style, field_to, field_icono } = entity.attributes;
	const link_data = extrctLinkData(field_to, sitemap, singleRelationships);

	if (link_data) {
		const icon = field_icono
			? {
					name: field_icono.includes("|") ? field_icono.split("|")[0] : field_icono,
					size: field_icono.includes("|") ? field_icono.split("|")[1] : 22,
			  }
			: null;
		return {
			id: entity.id,
			...link_data,
			toLabel: link_data.label,
			color: field_color ? field_color : "secondary",
			type: field_button_style ? field_button_style : "default",
			variant: field_button_style ? field_button_style : "contained",
			icon,
			fullWidth: false,
		};
	}
};
